/**************************************************
 * Nombre:       BarraSuperior
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography, useMediaQuery} from "@mui/material";
import {theme} from "../../../../Tema";
import {useState} from "react";
import {formatoFecha} from "../../../../Utilidades/formatoFecha";
import {COLORTEXTO} from "../../../Constantes";

const BarraSuperior = (
    {
        numeroFilas,
        filasPagina,
        page,
        cambiarPagina,
        filasPaginaCambia,
        funcionBuscar,
        clickAgregar,
        cargando
    }
) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const [palabra, setPalabra] = useState('')

    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{alignItems: 'center', color: COLORTEXTO, py: 1}}>

            <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 24, fontWeight: 600}}
                >{formatoFecha(new Date().getTime())}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', pr: 2}}>
                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {/*} <Typography
                        sx={{
                            transition: 'all .2s ease-in-out',
                            fontSize: 16,
                            fontWeight: 400,
                            borderBottom: 1,
                            borderColor: '#00000000',
                            cursor: 'pointer',
                            "&:hover": {
                                borderColor: theme.palette.primary.main,
                                color: theme.palette.primary.main,
                            }
                        }}>{'Todo'}</Typography>

                    {TIPOSMOVIMIENTOS.map((item, index) => (
                        <Typography
                            sx={{
                                transition: 'all .2s ease-in-out',
                                fontSize: 16,
                                fontWeight: 400,
                                borderBottom: 1,
                                borderColor: '#00000000',
                                cursor: 'pointer',
                                "&:hover": {
                                    borderColor: theme.palette.primary.main,
                                    color: theme.palette.primary.main,
                                }
                            }}>{item.nombre}</Typography>
                    ))}
*/}
                </Grid>
            </Grid>

        </Grid>
    )

}
export default BarraSuperior